export default __webpack_public_path__ + "static/cafe_36007-20cbbb3f3dfd084f830e0b979e8f9695.png";